import { useQuery } from '@tanstack/react-query';

import { agent } from 'api/agent';

export const fileKey = ['figures'];

const useProductFinder = () => useQuery({
  queryKey: fileKey,
  queryFn: () => agent.getClient().get('file-data/static?tag=products_pdf', {
    responseType: 'arraybuffer',
  }).then((response) => response.data),
});

export default useProductFinder;
